import { format } from 'date-fns';

export const useFormattedSlateDate = () => {
  const formatSlateDate = (dateString: string | Date | null | undefined): string => {
    if (!dateString) {
      return 'No date';
    }

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
      return 'Invalid date';
    }

    return format(date, "M/d '@' h:mm a");
  };

  return { formatSlateDate };
};
